const VrsteKonstalacija = () => {
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <h2>Poslovne konstelacije</h2>
                    <p>
                        Teme poslovnih konstelacija je dinamika poslovanja, a glavni akteri su: vlasnik, firma,
                        zaposlenici, klijenti, cilj, uspjeh, vizija, misija, odjeli...
                    </p>
                    <p>
                        Na individualnom nivou razmatraju se i osobni ciljevi i motivacija, zapreke ka ostvarenju
                        osobnih i poslovnih ciljeva i novac, kao materijalni dokaz poslovnog uspjeha.
                    </p>
                    <p>
                        Svi ti elementi i dinamika slijedi osnovne sistemske zakone:
                        <ul>
                            <li>pripadanje i energija koja iz toga proizlazi</li>
                            <li>poredak, odnosno struktura, hijerarhija i odgovornost.</li>
                        </ul>
                    </p>
                </div>
            </div>
        </>
    );
};

export default VrsteKonstalacija;
